import React from 'react';
import './DashboardBar.css';
import { Link } from 'react-router-dom';
import dashboardlogo from '../../../assets/images/dashboard-logo.svg';
import Button from '../../UI/Button/Button';
import SearchBox from '../../UI/SearchBox/SearchBox';
import searchIcon from '../../../assets/images/search-icon.svg';
import ConsoleLog from '../../../hoc/ConsoleLog/ConsoleLog';

/**
 * @desc Shows Recruiter dashboard contents
 * @param props
 * @return DOMElement
 */
const DashboardBar = (props) => {
  const addNewJobActiveClass = props.activeLink === 'manage-jobs' ? 'active' : 'inactive';
  const viewAllJobsActiveClass = props.activeLink === 'view-all-jobs' ? 'active' : 'inactive'
  const ReportsActiveClass = props.activeLink === 'manage-reports' ? 'active' : 'inactive'
  return (
  	<div className="recruiter-dashboard-bar">
      <Link className="dashboardlogo" to="/recruiter/dashboard">
        <img className="img-responsive" src={dashboardlogo} alt="logo"/>
      </Link>
      <Link className={addNewJobActiveClass + ' dashboard'} to ={'/recruiter/pool-import'} 
        onClick={()=>localStorage.setItem('zeroflag', true)}>Add New Job</Link>
      <Link className={viewAllJobsActiveClass + ' dashboard'} to="/recruiter/pool-view-all">View All Jobs</Link>
      <Link className={ReportsActiveClass + ' dashboard'} to="/recruiter/recruiter-all-reports">Reports</Link>
      {(props.isViewAllJobs) ? 
        <SearchBox 
          value={props.searchParam}
          onChange={props.onHandleSearch} 
          icon={searchIcon}
          isBorder={false}
          iconPosition={'right'}
          iconInside={false}
          className={(props.searchParam && props.searchParam !== "") ? "search-bar search-bar-active" : "search-bar" }
        /> 
      : "" }    
  	</div>
  );
}

DashboardBar.defaultProps = { 
  pool: {
    jobTitle: '',
    clientName: '',
    clientEmail: '',
    clientBHId: '',
    candidates: [{}]
  }
};

export default DashboardBar;



// WEBPACK FOOTER //
// ./src/components/Recruiter/DashboardBar/DashboardBar.js